import state from './state'
import * as mutations from './mutations'

const dispensing = {
    namespaced: true,
    state,
    mutations
}

export default dispensing;